import { loginApi } from './loginApi'
import { commonApi } from './commonApi'
import { visualDataApi } from './visualDataApi'
import { userManageApi } from './userManageApi'
import { dataAnalysisApi } from './dataAnalysisApi'
import { hospitalManageApi } from './hospitalManageApi'
import { systemConfigApi } from './systemConfigApi'

export default {
  loginApi,
  commonApi,
  visualDataApi,
  userManageApi,
  dataAnalysisApi,
  hospitalManageApi,
  systemConfigApi
}



// WEBPACK FOOTER //
// ./src/apis/index.js